import React, { useState, useEffect } from "react";
import { Box, Typography } from "@mui/material";
import Colors from "./Colors";
import TypographyComponent from "./TypographyComponent";

const CounterComponent = () => {
  const [time, setTime] = useState(14888); // Example: 04:08:08

  useEffect(() => {
    const interval = setInterval(() => {
      setTime((prevTime) => (prevTime > 0 ? prevTime - 1 : 0));
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  // Convert time to HH:MM:SS format
  const hours = Math.floor(time / 3600)
    .toString()
    .padStart(2, "0");
  const minutes = Math.floor((time % 3600) / 60)
    .toString()
    .padStart(2, "0");
  const seconds = (time % 60).toString().padStart(2, "0");

  return (
    <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
      {/* Hours */}
      <TimeBox label="Hours">
        <DigitBox digit={hours[0]} />
        <DigitBox digit={hours[1]} />
      </TimeBox>
      <Colon />

      {/* Minutes */}
      <TimeBox label="Minutes">
        <DigitBox digit={minutes[0]} />
        <DigitBox digit={minutes[1]} />
      </TimeBox>
      <Colon />

      {/* Seconds */}
      <TimeBox label="Seconds">
        <DigitBox digit={seconds[0]} />
        <DigitBox digit={seconds[1]} />
      </TimeBox>
    </Box>
  );
};

// TimeBox Component (Digit + Label)
const TimeBox = ({ label, children }) => (
  <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
    <Box sx={{ display: "flex", gap: 0.5 }}>{children}</Box>
    <Typography
      sx={{
        fontSize: 12,
        color: Colors.typoblue2,
        fontWeight: "bold",
        mt: 0.5,
      }}
    >
      {label}
    </Typography>
  </Box>
);

// Digit Box Component
const DigitBox = ({ digit }) => (
  <Box
    sx={{
      width: { xs: 20, md: 40 },
      height: { xs: 28, md: 56 },
      fontFamily: "Boogaloo",
      color: Colors.typoblue2,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontSize: { xs: 20, md: 44 },
      fontWeight: "bold",
      borderRadius: "8px",
      border: `3px solid ${Colors.white}`,
    }}
  >
    {digit}
  </Box>
);

// Colon Separator Component
const Colon = () => (
  <TypographyComponent
    sx={{
      fontSize: { xs: "16px", md: "36px" },
      color: Colors.white,
      lineHeight: { xs: "16px", md: "36px" },
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    }}
  >
    :
  </TypographyComponent>
);

export default CounterComponent;
